import { Box, Chip, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux'
import SharedDialog from '../../common/dialog/SharedDialog';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LANGS_WITHOUT_TW } from '../../../Constants/lang';

const LANGS = LANGS_WITHOUT_TW

const localeColors = {
  EN: '#4A90D9',
  ZH_CN: '#E74C3C',
  ZH_HK: '#2ECC71',
}

const MultiLangDialogAndSingleDisplayIpt = ({
    item = false,
    optionIdx,
    keyName,
    itemKeyName,
    valueObj,
    label: optionLabel,
    price,
    inputType,
    handleMultiIptChange,
    handleOptions
}) => {

    const lang = useSelector(state => state.lang.ui.lang);
    const [open, setOpen] = React.useState(false)

    const handleToggleOpen = () => setOpen(!open)

    // MUI Select onChange event target is a plain { value, name } object
    // without dataset, so we wrap it to inject the data attributes manually
    const handleSelectChange = (e) => {
        handleMultiIptChange({
            target: {
                ...e.target,
                dataset: { keyName, itemKeyName },
            },
        })
    }

    const displayText = valueObj?.[lang] || ''
    const triggerLabel = item
        ? `Option ${optionIdx + 1}${price ? ` · $${price}` : ''}`
        : keyName

    const triggerInput = item ? (
        <TextField
            variant='outlined'
            type='text'
            label={triggerLabel}
            name={"" + optionIdx}
            value={displayText}
            color='success'
            size="small"
            helperText={inputType ? `Input: ${inputType}` : undefined}
            InputProps={{
                readOnly: true,
                endAdornment: (
                    <InputAdornment position="end" sx={{ gap: 0.25 }}>
                        <Tooltip title="Edit translations"><ExpandMoreIcon sx={{ width: 18, height: 18, color: 'action.active', cursor: 'pointer' }} /></Tooltip>
                        <Tooltip title="Remove option"><IconButton disableRipple size="small" color="error" onClick={(e) => { e.stopPropagation(); handleOptions('d', { keyName, itemKeyName })(e); }}>-</IconButton></Tooltip>
                    </InputAdornment>
                ),
            }}
            onClick={handleToggleOpen}
            sx={{ cursor: 'pointer', '& .MuiInputBase-input': { cursor: 'pointer' } }}
        />
    ) : (
        <TextField
            variant='filled'
            type='text'
            label={keyName}
            name={keyName}
            value={valueObj?.[lang] || ''}
            color='success'
            InputProps={{
                readOnly: true,
                endAdornment: (
                    <InputAdornment position="end">
                        <EditIcon sx={{ width: 16, height: 16, color: 'action.active' }} />
                    </InputAdornment>
                ),
            }}
            onClick={handleToggleOpen}
            sx={{ cursor: 'pointer', '& .MuiInputBase-input': { cursor: 'pointer' } }}
        />
    )

    return (
        <React.Fragment>
            {triggerInput}
            <SharedDialog
                maxWidth='md'
                open={open}
                onClose={() => setOpen(false)}
                title={item ? `Edit Option ${optionIdx + 1}` : `Edit ${keyName}`}
                PaperProps={{ sx: { borderRadius: '12px' } }}
                content={
                    <Grid container spacing={1.5}>
                        {LANGS.map(langKey => (
                            <Grid key={langKey} item xs={12} sm={4}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                    <Chip
                                        label={langKey}
                                        size="small"
                                        sx={{
                                            height: 18, fontSize: 9, fontWeight: 700, alignSelf: 'flex-start',
                                            bgcolor: localeColors[langKey] || '#64748b', color: '#fff',
                                            '& .MuiChip-label': { px: 0.8 },
                                        }}
                                    />
                                    <TextField
                                        multiline
                                        variant='filled'
                                        type='text'
                                        label=''
                                        name={langKey}
                                        inputProps={{ 'data-key-name': keyName, 'data-item-key-name': itemKeyName }}
                                        defaultValue={valueObj?.[langKey] || ''}
                                        color='success'
                                        rows={4}
                                        sx={{ width: '100%' }}
                                        onChange={handleMultiIptChange}
                                    />
                                </Box>
                            </Grid>
                        ))}
                        {item && (
                            <>
                                <Grid item xs={6}>
                                    <TextField
                                        variant='filled'
                                        type='text'
                                        label='Price'
                                        name='price'
                                        inputProps={{ 'data-key-name': keyName, 'data-item-key-name': itemKeyName }}
                                        defaultValue={price}
                                        color='success'
                                        sx={{ width: '100%' }}
                                        onChange={handleMultiIptChange}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id={`opt-input-type-label-${optionIdx}`}>Input Type</InputLabel>
                                        <Select
                                            variant='filled'
                                            labelId={`opt-input-type-label-${optionIdx}`}
                                            label="Input Type"
                                            name='inputType'
                                            defaultValue={inputType || ''}
                                            color='success'
                                            onChange={handleSelectChange}
                                        >
                                            <MenuItem value={''}>None</MenuItem>
                                            <MenuItem value={'TEXT_FIELD'}>TEXT_FIELD</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant='filled'
                                        type='text'
                                        label='Label'
                                        name='label'
                                        helperText='Use for mobile'
                                        inputProps={{ 'data-key-name': keyName, 'data-item-key-name': itemKeyName }}
                                        defaultValue={optionLabel || ''}
                                        color='success'
                                        sx={{ width: '100%' }}
                                        onChange={handleMultiIptChange}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                }
            />
        </React.Fragment>
    )
}

export default MultiLangDialogAndSingleDisplayIpt